module.exports = __webpack_public_path__ + "img/ts3.5206aa3f.png";